module.exports = __webpack_public_path__ + "img/star-5.0d351a06.svg";